import { IAnimationSetting } from '@src/slide/domain/ui-model/element-modeles/transition/interface';
import { TransitionTarget } from '@src/slide/domain/ui-model/element-modeles/transition/constants';
import { EightDirectionType } from '@src/slide/domain/ui-model/element-modeles/transition/direction/constants';

export const TransitionConfig = {
    /** opacity **/
    OPACITY_HIDE: { opacity: 0 },
    OPACITY_SHOW: { opacity: 1 },
    /** translate **/
    TRANSLATE_SHOW: { translateX: 0, translateY: 0 },
    TRANSLATE_VERTICAL_POSITIVE_HIDE: { translateX: 0, translateY: 1 },
    TRANSLATE_VERTICAL_NEGATIVE_HIDE: { translateX: 0, translateY: -1 },
    TRANSLATE_HORIZONTAL_POSITIVE_HIDE: { translateX: 1, translateY: 0 },
    TRANSLATE_HORIZONTAL_NEGATIVE_HIDE: { translateX: -1, translateY: 0 },
    TRANSLATE_LEFT_DOWN_HIDE: { translateX: -1, translateY: 1 },
    TRANSLATE_LEFT_UP_HIDE: { translateX: -1, translateY: -1 },
    TRANSLATE_RIGHT_DOWN_HIDE: { translateX: 1, translateY: 1 },
    TRANSLATE_RIGHT_UP_HIDE: { translateX: 1, translateY: -1 },
    /** z-index **/
    Z_INDEX_LEVEL_0: { zIndex: 0 },
    Z_INDEX_LEVEL_1: { zIndex: 1 },
    /** scale **/
    SCALE_NORMAL: { scale: 1 },
    SCALE_LARGE: { scale: 10 },
    SCALE_SMALL: { scale: 0.5 },
    SCALE_ZERO: { scale: 0 },
    /** rotate **/
    ROTATE_ZERO: { rotate: 0 },
    ROTATE_TWO_TURNS: { rotate: 405 },
    /** origin **/
    ORIGIN_LEFT_CENTER: { originX: 0, originY: 0.5 },
    ORIGIN_RIGHT_CENTER: { originX: 1, originY: 0.5 },
    ORIGIN_CENTER: { originX: 0.5, originY: 0.5 },
    ORIGIN_TOP_CENTER: { originX: 0.5, originY: 0 },
    ORIGIN_BOTTOM_CENTER: { originX: 0.5, originY: 1 },
    /** switch **/
    SWITCH_START: { rotateY: 0, translateX: 0, translateZ: 0 },
    SWITCH_END: { rotateY: 0, translateX: 0, translateZ: -400 },
    SWITCH_LEFT_MIDDLE: { rotateY: 15, translateX: -0.5, translateZ: -200 },
    SWITCH_RIGHT_MIDDLE: { rotateY: -15, translateX: 0.5, translateZ: -200 },
    /** flip **/
    FLIP_START: { rotateY: 0 },
    FLIP_MIDDLE: { rotateY: 90 },
    FLIP_END: { rotateY: -90 },
    /** gallery **/
    GALLERY_START: { rotateY: 0, translateZ: 0, scale: 1 },
    GALLERY_LEFT: { rotateY: -10, translateZ: -100, scale: 0.95 },
    GALLERY_RIGHT: { rotateY: 10, translateZ: -100, scale: 0.95 },
    /** progress **/
    PROGRESS_START: { progress: 0 },
    PROGRESS_END: { progress: 1 },
};

export function getPullConfig(direction: EightDirectionType): IAnimationSetting[] {
    if (direction === EightDirectionType.UP) {
        return [{
            fromStyle: TransitionConfig.TRANSLATE_SHOW,
            toStyle: TransitionConfig.TRANSLATE_VERTICAL_NEGATIVE_HIDE,
            target: TransitionTarget.EXIT,
        }];
    }
    if (direction === EightDirectionType.LEFT) {
        return [{
            fromStyle: TransitionConfig.TRANSLATE_SHOW,
            toStyle: TransitionConfig.TRANSLATE_HORIZONTAL_NEGATIVE_HIDE,
            target: TransitionTarget.EXIT,
        }];
    }
    if (direction === EightDirectionType.DOWN) {
        return [{
            fromStyle: TransitionConfig.TRANSLATE_SHOW,
            toStyle: TransitionConfig.TRANSLATE_VERTICAL_POSITIVE_HIDE,
            target: TransitionTarget.EXIT,
        }];
    }
    if (direction === EightDirectionType.LEFT_DOWN) {
        return [{
            fromStyle: TransitionConfig.TRANSLATE_SHOW,
            toStyle: TransitionConfig.TRANSLATE_LEFT_DOWN_HIDE,
            target: TransitionTarget.EXIT,
        }];
    }
    if (direction === EightDirectionType.LEFT_UP) {
        return [{
            fromStyle: TransitionConfig.TRANSLATE_SHOW,
            toStyle: TransitionConfig.TRANSLATE_LEFT_UP_HIDE,
            target: TransitionTarget.EXIT,
        }];
    }
    if (direction === EightDirectionType.RIGHT_DOWN) {
        return [{
            fromStyle: TransitionConfig.TRANSLATE_SHOW,
            toStyle: TransitionConfig.TRANSLATE_RIGHT_DOWN_HIDE,
            target: TransitionTarget.EXIT,
        }];
    }
    if (direction === EightDirectionType.RIGHT_UP) {
        return [{
            fromStyle: TransitionConfig.TRANSLATE_SHOW,
            toStyle: TransitionConfig.TRANSLATE_RIGHT_UP_HIDE,
            target: TransitionTarget.EXIT,
        }];
    }
    return [{
        fromStyle: TransitionConfig.TRANSLATE_SHOW,
        toStyle: TransitionConfig.TRANSLATE_HORIZONTAL_POSITIVE_HIDE,
        target: TransitionTarget.EXIT,
    }];
}

export function getCoverConfig(direction: EightDirectionType): IAnimationSetting[] {
    if (direction === EightDirectionType.UP) {
        return [{
            fromStyle: {
                ...TransitionConfig.TRANSLATE_VERTICAL_POSITIVE_HIDE,
                ...TransitionConfig.Z_INDEX_LEVEL_1,
            },
            toStyle: {
                ...TransitionConfig.TRANSLATE_SHOW,
                ...TransitionConfig.Z_INDEX_LEVEL_1,
            },
            target: TransitionTarget.ENTER,
        }];
    }
    if (direction === EightDirectionType.LEFT) {
        return [{
            fromStyle: {
                ...TransitionConfig.TRANSLATE_HORIZONTAL_POSITIVE_HIDE,
                ...TransitionConfig.Z_INDEX_LEVEL_1,
            },
            toStyle: {
                ...TransitionConfig.TRANSLATE_SHOW,
                ...TransitionConfig.Z_INDEX_LEVEL_1,
            },
            target: TransitionTarget.ENTER,
        }];
    }
    if (direction === EightDirectionType.DOWN) {
        return [{
            fromStyle: {
                ...TransitionConfig.TRANSLATE_VERTICAL_NEGATIVE_HIDE,
                ...TransitionConfig.Z_INDEX_LEVEL_1,
            },
            toStyle: {
                ...TransitionConfig.TRANSLATE_SHOW,
                ...TransitionConfig.Z_INDEX_LEVEL_1,
            },
            target: TransitionTarget.ENTER,
        }];
    }
    if (direction === EightDirectionType.LEFT_DOWN) {
        return [{
            fromStyle: {
                ...TransitionConfig.TRANSLATE_RIGHT_UP_HIDE,
                ...TransitionConfig.Z_INDEX_LEVEL_1,
            },
            toStyle: {
                ...TransitionConfig.TRANSLATE_SHOW,
                ...TransitionConfig.Z_INDEX_LEVEL_1,
            },
            target: TransitionTarget.ENTER,
        }];
    }
    if (direction === EightDirectionType.LEFT_UP) {
        return [{
            fromStyle: {
                ...TransitionConfig.TRANSLATE_RIGHT_DOWN_HIDE,
                ...TransitionConfig.Z_INDEX_LEVEL_1,
            },
            toStyle: {
                ...TransitionConfig.TRANSLATE_SHOW,
                ...TransitionConfig.Z_INDEX_LEVEL_1,
            },
            target: TransitionTarget.ENTER,
        }];
    }
    if (direction === EightDirectionType.RIGHT_DOWN) {
        return [{
            fromStyle: {
                ...TransitionConfig.TRANSLATE_LEFT_UP_HIDE,
                ...TransitionConfig.Z_INDEX_LEVEL_1,
            },
            toStyle: {
                ...TransitionConfig.TRANSLATE_SHOW,
                ...TransitionConfig.Z_INDEX_LEVEL_1,
            },
            target: TransitionTarget.ENTER,
        }];
    }
    if (direction === EightDirectionType.RIGHT_UP) {
        return [{
            fromStyle: {
                ...TransitionConfig.TRANSLATE_LEFT_DOWN_HIDE,
                ...TransitionConfig.Z_INDEX_LEVEL_1,
            },
            toStyle: {
                ...TransitionConfig.TRANSLATE_SHOW,
                ...TransitionConfig.Z_INDEX_LEVEL_1,
            },
            target: TransitionTarget.ENTER,
        }];
    }
    return [{
        fromStyle: {
            ...TransitionConfig.TRANSLATE_HORIZONTAL_NEGATIVE_HIDE,
            ...TransitionConfig.Z_INDEX_LEVEL_1,
        },
        toStyle: {
            ...TransitionConfig.TRANSLATE_SHOW,
            ...TransitionConfig.Z_INDEX_LEVEL_1,
        },
        target: TransitionTarget.ENTER,
    }];
}
